// extracted by mini-css-extract-plugin
export default {"section":"AuthSection_section__s5LaW"};